import React, { useEffect, useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import {
  Float,
  Box,
  Environment,
  RoundedBox,
  OrbitControls
} from "@react-three/drei";
import "./styles.css";
import {
  Bloom,
  SMAA,
  DepthOfField,
  EffectComposer,
  Noise,
  Vignette
} from "@react-three/postprocessing";
import {
  editable as e,
  SheetProvider,
  useCurrentSheet,
  PerspectiveCamera
} from "@theatre/r3f";
import { getProject, sheet, val } from "@theatre/core";
import studio from "@theatre/studio";
import extension from "@theatre/r3f/dist/extension";
import Cubicles from "./Cubicles";
import Animation1 from "./Animation1.json";
// studio.initialize();
// studio.extend(extension);

const demoSheet = getProject("Demo Project", { state: Animation1 }).sheet(
  "Demo Sheet"
);

export default function App() {
  demoSheet.sequence.play({
    iterationCount: Infinity,
    range: [0, 6]
  });
  return (
    <Canvas
      camera={{ fov: 50, position: [2, 0.3, 4.5] }}
      gl={{ alpha: false, antialias: false }}
    >
      <SheetProvider sheet={demoSheet}>
        <pointLight position={[10, 10, 10]} intensity={1.5} />
        {/* <directionalLight intensity={0.5} /> */}
        <color attach="background" args={["#090809"]} />
        <ambientLight intensity={0.6} />

        <Cubicles />

        <OrbitControls />
        <Environment preset="dawn" />

        <EffectComposer disableNormalPass multisampling={8}>
          <Bloom
            radius={0.65}
            mipmapBlur
            luminanceThreshold={0.6}
            luminanceSmoothing={0.9}
          />
          <Vignette eskil={false} offset={0.1} darkness={0.6} />
        </EffectComposer>
      </SheetProvider>
    </Canvas>
  );
}
